import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_CREATE_DEV_API_KEY_BEGIN,
  APP_SETTING_CREATE_DEV_API_KEY_SUCCESS,
  APP_SETTING_CREATE_DEV_API_KEY_FAILURE,
  APP_SETTING_CREATE_DEV_API_KEY_DISMISS_ERROR,
} from './constants';

export function createDevApiKey(args = {}) {
  const { projectId, version, payload } = args;
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_CREATE_DEV_API_KEY_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(projectId);
    const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/developer-apis/${projectId}/devApiKeys`;

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(url, payload, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_CREATE_DEV_API_KEY_SUCCESS,
            data: res.data,
          });
          toast.success('API Key generated successfully!');
          resolve(res.data);
        },
        (err) => {
          const errMsg = err?.response?.data?.message || err?.message || 'Failed to create API key';
          toast.error(errMsg);
          dispatch({
            type: APP_SETTING_CREATE_DEV_API_KEY_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateDevApiKeyError() {
  return {
    type: APP_SETTING_CREATE_DEV_API_KEY_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_CREATE_DEV_API_KEY_BEGIN:
      return {
        ...state,
        createDevApiKeyPending: true,
        createDevApiKeyError: null,
      };

    case APP_SETTING_CREATE_DEV_API_KEY_SUCCESS:
      return {
        ...state,
        createDevApiKeyPending: false,
        createDevApiKeyError: null,
        devApiKeys: [action.data.key, ...(state.devApiKeys || [])],
      };

    case APP_SETTING_CREATE_DEV_API_KEY_FAILURE:
      return {
        ...state,
        createDevApiKeyPending: false,
        createDevApiKeyError: action.data.error,
      };

    case APP_SETTING_CREATE_DEV_API_KEY_DISMISS_ERROR:
      return {
        ...state,
        createDevApiKeyError: null,
      };

    default:
      return state;
  }
}
